<template>
  <input
    class="apple-ui-slider"
    type="range"
    :value="value"
    :min="min"
    :max="max"
    :step="step"
    :disabled="disabled"
    :style="sliderStyle"
    v-bind="$attrs"
    v-on="forwardedListeners"
    @input="onInput"
    @change="onChange"
  />
</template>

<script>
export default {
  name: 'AppleSlider',
  inheritAttrs: false,
  props: {
    value: { type: [Number, String], default: 0 },
    min: { type: [Number, String], default: 0 },
    max: { type: [Number, String], default: 100 },
    step: { type: [Number, String], default: 1 },
    disabled: Boolean,
  },
  computed: {
    sliderStyle() {
      const min = Number(this.min), max = Number(this.max), value = Number(this.value);
      const percent = Number.isFinite(min) && Number.isFinite(max) && max > min && Number.isFinite(value)
        ? Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100)) : 0;
      return { '--apple-slider-progress': `${percent}%` };
    },
    forwardedListeners() {
      const listeners = { ...this.$listeners };
      delete listeners.input;
      delete listeners.change;
      return listeners;
    },
  },
  methods: {
    numericValue(event) {
      const value = Number(event.target.value);
      return Number.isFinite(value) ? value : 0;
    },
    onInput(event) { this.$emit('input', this.numericValue(event)); },
    onChange(event) { this.$emit('change', this.numericValue(event)); },
  },
};
</script>

<style scoped>
.apple-ui-slider {
  display: block;
  width: 100%;
  min-width: 72px;
  height: 20px;
  margin: 0;
  padding: 0;
  appearance: none;
  background: transparent;
  cursor: pointer;
  accent-color: var(--apple-ui-range-fill, var(--apple-ui-accent, var(--color-primary)));
  -webkit-tap-highlight-color: transparent;
}
.apple-ui-slider::-webkit-slider-runnable-track { height: 3px; border-radius: 99px; background: linear-gradient(to right, var(--apple-ui-range-fill, var(--apple-ui-accent, var(--color-primary))) 0 var(--apple-slider-progress), var(--apple-ui-range-track, #c7c7cc) var(--apple-slider-progress) 100%); }
.apple-ui-slider::-webkit-slider-thumb { width: 12px; height: 12px; margin-top: -4.5px; appearance: none; border: 0; border-radius: 50%; background: var(--apple-ui-range-thumb, #fff); box-shadow: 0 1px 3px rgb(0 0 0 / 22%); }
.apple-ui-slider::-moz-range-track { height: 3px; border-radius: 99px; background: var(--apple-ui-range-track, #c7c7cc); }
.apple-ui-slider::-moz-range-progress { height: 3px; border-radius: 99px; background: var(--apple-ui-range-fill, var(--apple-ui-accent, var(--color-primary))); }
.apple-ui-slider::-moz-range-thumb { width: 12px; height: 12px; border: 0; border-radius: 50%; background: var(--apple-ui-range-thumb, #fff); box-shadow: 0 1px 3px rgb(0 0 0 / 22%); }
.apple-ui-slider:focus { outline: none; }
.apple-ui-slider:focus-visible::-webkit-slider-thumb { box-shadow: 0 0 0 2px var(--apple-ui-focus, var(--apple-ui-accent)), 0 1px 3px rgb(0 0 0 / 22%); }
.apple-ui-slider:focus-visible::-moz-range-thumb { box-shadow: 0 0 0 2px var(--apple-ui-focus, var(--apple-ui-accent)), 0 1px 3px rgb(0 0 0 / 22%); }
.apple-ui-slider:disabled { opacity: .45; cursor: default; }
@media (prefers-reduced-motion: reduce) { .apple-ui-slider { scroll-behavior: auto; } }
</style>
